import { client } from "@nju/http-client";
import { isError } from "@nju/result";
import { ISetMnpModeResult } from "./types";
import { orchestrator as serverResponse } from "./validators";

type ISetMnpModeParams =
  | {
      portingMode: "EOP";
      sourceContractType: "PREPAID" | "POSTPAID";
      orchestratorId: string;
    }
  | {
      portingMode: "DAY";
      sourceContractType: "PREPAID" | "POSTPAID";
      transferDate: string;
      orchestratorId: string;
    };

function getParams(params: ISetMnpModeParams) {
  if (params.portingMode === "EOP") {
    return {
      portingMode: params.portingMode,
      sourceContractType: params.sourceContractType,
    };
  }

  if (params.portingMode === "DAY") {
    return {
      portingMode: params.portingMode,
      sourceContractType: params.sourceContractType,
      transferDate: params.transferDate,
    };
  }

  throw new Error("invalid porting mode");
}

export async function setMnpMode(
  params: ISetMnpModeParams,
): Promise<ISetMnpModeResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${params.orchestratorId}/actions/MNP_MODE_SET`,
    {
      method: "post",
      validator: serverResponse,
      json: {
        mnp: {
          ...getParams(params),
        },
      },
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (isError(result)) {
    return result;
  }

  return result;
}
